/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 95xp9cYcv7HrNWpFWWhbcv

import {
  createStyleTokensProvider,
  createUseStyleTokens,
} from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectModule

import projectcss from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss

const data = {
  base: projectcss.plasmic_tokens,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);

export const StyleTokensProvider = createStyleTokensProvider(
  data,
  _useGlobalVariants
);
